/* =========================================================
   PUREOIL OLIEGIDS PRO
   assets/pureoil-oliegids.js
========================================================= */


/* =========================================================
   OLIËN
========================================================= */

const RAW = `
Rozemarijn|Salvia rosmarinus|E|🌿|Haar,Hoofdhuid,Focus,Diffuser
Frankincense|Boswellia carterii|E|🪵|Huid,Meditatie,Geur
Tea Tree|Melaleuca alternifolia|E|🌱|Huid,Reiniging,Voeten,Diffuser
Lavendel|Lavandula angustifolia|E|💜|Slaap,Ontspanning,Huid,Diffuser
Pepermunt|Mentha piperita|E|❄️|Focus,Fris,Hoofdhuid,Diffuser
Kruidnagel|Syzygium aromaticum|E|🌰|Warm,Kruidig,Geur,Diffuser
Oregano|Origanum vulgare|E|🌿|Kruidig,Reiniging,Diffuser
Rozen|Rosa damascena|E|🌹|Geur,Huid,Ontspanning,Diffuser
Ylang Ylang|Cananga odorata|E|🌼|Geur,Ontspanning,Haar,Diffuser
Kamille|Matricaria chamomilla|E|🌼|Slaap,Ontspanning,Huid,Diffuser
Eucalyptus|Eucalyptus globulus|E|🍃|Fris,Diffuser,Massage,Ademhaling
Geranium|Pelargonium graveolens|E|🌸|Huid,Geur,Ontspanning,Diffuser
Cederhout|Cedrus atlantica|E|🌲|Haar,Geur,Ontspanning,Diffuser
Patchouli|Pogostemon cablin|E|🍂|Geur,Huid,Aards,Diffuser
Bergamot|Citrus bergamia|E|🍋|Ontspanning,Citrus,Geur,Diffuser
Kurkuma|Curcuma longa|E|🟡|Kruidig,Huid,Geur,Diffuser
Jasmijn|Jasminum officinale|E|🤍|Geur,Ontspanning,Huid,Diffuser
Sandelhout|Santalum album|E|🟤|Meditatie,Geur,Huid,Diffuser
Citroen|Citrus limon|E|🍋|Fris,Citrus,Diffuser,Geur
Mirre|Commiphora myrrha|E|🪵|Geur,Meditatie,Huid,Diffuser
Citronella|Cymbopogon nardus|E|🌾|Fris,Buiten,Diffuser,Geur
Lotus|Nelumbo nucifera|E|🪷|Geur,Ontspanning,Diffuser
Vanille|Vanilla planifolia|E|🤎|Warm,Geur,Ontspanning,Diffuser
Tijm|Thymus vulgaris|E|🌿|Kruidig,Fris,Diffuser
Dennen|Pinus sylvestris|E|🌲|Fris,Bos,Diffuser,Geur
Sinaasappel|Citrus sinensis|E|🍊|Geur,Citrus,Ontspanning,Diffuser
Neroli|Citrus aurantium amara|E|🌼|Geur,Ontspanning,Huid,Diffuser
Kaneel|Cinnamomum zeylanicum|E|🪵|Warm,Kruidig,Geur,Diffuser
Venkel|Foeniculum vulgare|E|🌱|Kruidig,Geur,Diffuser
Salie|Salvia officinalis|E|🌿|Kruidig,Geur,Diffuser,Haar
Citroengras|Cymbopogon citratus|E|🌾|Fris,Citrus,Diffuser,Geur
Mandarijn|Citrus reticulata|E|🍊|Citrus,Ontspanning,Geur,Diffuser
Gember|Zingiber officinale|E|🫚|Warm,Kruidig,Geur,Diffuser
Basilicum|Ocimum basilicum|E|🌿|Kruidig,Focus,Diffuser,Geur
Knoflook|Allium sativum|E|🧄|Kruidig,Haar,Geur

Batana Olie|Elaeis oleifera|D|🥥|Haar,Droog,Glans,Hoofdhuid,Rijk
Castor Olie|Ricinus communis|D|💧|Haar,Wenkbrauwen,Droog,Basisolie,Rijk,Hoofdhuid
Jojoba Olie|Simmondsia chinensis|D|🌾|Huid,Haar,Gezicht,Basisolie,Licht,Hoofdhuid
Pompoenpitolie|Cucurbita pepo|D|🎃|Haar,Huid,Hoofdhuid,Basisolie
Argan Olie|Argania spinosa|D|✨|Haar,Huid,Nagels,Droog,Glans,Gezicht
Amla Olie|Phyllanthus emblica|D|🌿|Haar,Hoofdhuid,Glans,Droog
Kokos Olie|Cocos nucifera|D|🥥|Haar,Huid,Massage,Droog,Rijk
Zwarte Zaad Olie|Nigella sativa|D|⚫|Haar,Huid,Hoofdhuid,Basisolie
Vitamine E Olie|Tocopherol|D|✨|Huid,Droog,Nagels,Basisolie,Rijk
Zoete Amandel Olie|Prunus amygdalus dulcis|D|🌰|Massage,Huid,Droog,Basisolie
Aloë Vera Olie|Aloe barbadensis|D|🌱|Huid,Haar,Verzorging,Droog
Rozenbottel Olie|Rosa canina|D|🌹|Gezicht,Huid,Verzorging,Droog
Moringa Olie|Moringa oleifera|D|🌿|Haar,Huid,Droog,Glans
Neem Olie|Azadirachta indica|D|🌿|Huid,Haar,Hoofdhuid,Verzorging,Rijk
Frambozenpit Olie|Rubus idaeus|D|🍓|Gezicht,Huid,Verzorging,Droog,Licht
Avocado Olie|Persea gratissima|D|🥑|Droog,Huid,Haar,Rijk
Abrikozenpit Olie|Prunus armeniaca|D|🍑|Gezicht,Huid,Massage,Basisolie,Licht
Cactusvijg Olie|Opuntia ficus-indica|D|🌵|Gezicht,Huid,Droog,Verzorging
Marula Olie|Sclerocarya birrea|D|🥜|Huid,Haar,Droog,Glans
Tarwekiem Olie|Triticum vulgare|D|🌾|Huid,Droog,Basisolie,Verzorging,Rijk
Lijnzaad Olie|Linum usitatissimum|D|🌾|Haar,Huid,Droog,Basisolie
Olijf Olie|Olea europaea|D|🫒|Haar,Huid,Nagels,Massage,Droog,Rijk
Fenegriek Olie|Trigonella foenum-graecum|D|🌿|Haar,Hoofdhuid,Verzorging,Basisolie
Walnoot Olie|Juglans regia|D|🌰|Huid,Haar,Massage,Basisolie
Teunisbloem Olie|Oenothera biennis|D|🌼|Huid,Gezicht,Droog,Verzorging
Druivenpit Olie|Vitis vinifera|D|🍇|Huid,Licht,Massage,Basisolie,Gezicht
Duindoornolie|Hippophae rhamnoides|D|🧡|Huid,Gezicht,Verzorging,Droog,Rijk
`;


/* =========================================================
   HERKOMST / EXTRACTIE / HOUDBAARHEID
========================================================= */

const META = {

  "Rozemarijn": [
    "Middellandse Zeegebied",
    "Bladeren en bloeiende toppen",
    "Stoomdestillatie",
    "2–3 jaar",
    "Fris, groen en kruidig",
    "Dun"
  ],

  "Frankincense": [
    "India",
    "Hars van de Boswellia-boom",
    "Stoomdestillatie",
    "3–5 jaar",
    "Mild, warm, licht houtachtig en licht kruidig",
    "Dun"
  ],

  "Tea Tree": [
    "Australië",
    "Bladeren en jonge takjes",
    "Stoomdestillatie",
    "2–3 jaar",
    "Fris, kruidig en krachtig",
    "Dun"
  ],

  "Lavendel": [
    "Middellandse Zeegebied",
    "Bloeiende toppen",
    "Stoomdestillatie",
    "2–3 jaar",
    "Zacht, bloemig en kruidig",
    "Dun"
  ],

  "Pepermunt": [
    "Europa en Noord-Amerika",
    "Bladeren",
    "Stoomdestillatie",
    "2–3 jaar",
    "Intens fris en muntachtig",
    "Dun"
  ],

  "Kruidnagel": [
    "Zuidoost-Azië",
    "Bloemknoppen",
    "Stoomdestillatie",
    "3–5 jaar",
    "Warm, krachtig en kruidig",
    "Dun"
  ],

  "Oregano": [
    "Middellandse Zeegebied",
    "Bladeren en bloeiende toppen",
    "Stoomdestillatie",
    "3–4 jaar",
    "Zeer krachtig en kruidig",
    "Dun"
  ],

  "Rozen": [
    "Onder andere Bulgarije en Turkije",
    "Bloemblaadjes",
    "Stoomdestillatie of extractie, afhankelijk van producttype",
    "3–5 jaar",
    "Vol, bloemig en elegant",
    "Dun tot licht voller"
  ],

  "Ylang Ylang": [
    "Zuidoost-Azië en eilanden in de Indische Oceaan",
    "Bloemen",
    "Stoomdestillatie",
    "3–5 jaar",
    "Intens bloemig, zoet en exotisch",
    "Dun"
  ],

  "Kamille": [
    "Europa",
    "Bloemen",
    "Stoomdestillatie",
    "3–5 jaar",
    "Zacht, kruidig en bloemig",
    "Dun"
  ],

  "Eucalyptus": [
    "Australië",
    "Bladeren",
    "Stoomdestillatie",
    "2–3 jaar",
    "Fris, helder en karakteristiek",
    "Dun"
  ],

  "Geranium": [
    "Onder andere Zuid-Afrika en Egypte",
    "Bladeren en bloemen",
    "Stoomdestillatie",
    "3–4 jaar",
    "Bloemig, groen en licht roosachtig",
    "Dun"
  ],

  "Cederhout": [
    "Noord-Afrika",
    "Hout",
    "Stoomdestillatie",
    "4–6 jaar",
    "Droog, warm en houtachtig",
    "Dun"
  ],

  "Patchouli": [
    "Zuidoost-Azië",
    "Bladeren",
    "Stoomdestillatie",
    "5+ jaar",
    "Diep, aards en zoet-houtachtig",
    "Iets voller"
  ],

  "Bergamot": [
    "Italië, vooral Calabrië",
    "Schil",
    "Meestal koude persing",
    "1–2 jaar",
    "Frisse, elegante citrus",
    "Dun"
  ],

  "Kurkuma": [
    "Zuid-Azië",
    "Wortelstok",
    "Stoomdestillatie",
    "3–5 jaar",
    "Warm, kruidig en aards",
    "Dun"
  ],

  "Jasmijn": [
    "Onder andere India en Egypte",
    "Bloemen",
    "Vaak solventextractie tot absolute",
    "3–5 jaar",
    "Intens, bloemig, rijk en zoet",
    "Licht voller"
  ],

  "Sandelhout": [
    "Zuid- en Zuidoost-Azië",
    "Kernhout",
    "Stoomdestillatie",
    "5–8 jaar",
    "Zacht, romig, warm en houtachtig",
    "Iets voller"
  ],

  "Citroen": [
    "Mediterrane regio",
    "Schil",
    "Meestal koude persing",
    "1–2 jaar",
    "Helder, fris en citrusachtig",
    "Dun"
  ],

  "Mirre": [
    "Oost-Afrika en Arabisch Schiereiland",
    "Hars",
    "Stoomdestillatie",
    "4–6 jaar",
    "Warm, harsachtig en diep",
    "Licht voller"
  ],

  "Citronella": [
    "Tropisch Azië",
    "Gras",
    "Stoomdestillatie",
    "2–3 jaar",
    "Fris, groen en citroenachtig",
    "Dun"
  ],

  "Lotus": [
    "Azië",
    "Bloemen",
    "Vaak extractie tot absolute",
    "3–5 jaar",
    "Zacht, bloemig en exotisch",
    "Afhankelijk van extract"
  ],

  "Vanille": [
    "Tropische regio's, onder andere Madagaskar",
    "Vanillepeulen",
    "Vaak solvent- of CO₂-extractie",
    "3–5 jaar",
    "Zoet, warm en gourmand",
    "Vaak iets voller"
  ],

  "Tijm": [
    "Middellandse Zeegebied",
    "Bladeren en bloeiende toppen",
    "Stoomdestillatie",
    "3–4 jaar",
    "Sterk, fris en kruidig",
    "Dun"
  ],

  "Dennen": [
    "Europa en Azië",
    "Naalden",
    "Stoomdestillatie",
    "2–3 jaar",
    "Fris, groen en bosachtig",
    "Dun"
  ],

  "Sinaasappel": [
    "Citrusproducerende regio's",
    "Schil",
    "Koude persing",
    "1–2 jaar",
    "Zoet en zonnig citrus",
    "Dun"
  ],

  "Neroli": [
    "Middellandse Zeegebied",
    "Oranjebloesem",
    "Stoomdestillatie",
    "3–5 jaar",
    "Bloemig, citrusachtig en verfijnd",
    "Dun"
  ],

  "Kaneel": [
    "Sri Lanka en tropisch Azië",
    "Schors of blad, afhankelijk van product",
    "Stoomdestillatie",
    "3–5 jaar",
    "Zeer warm en kruidig",
    "Dun"
  ],

  "Venkel": [
    "Middellandse Zeegebied",
    "Zaden",
    "Stoomdestillatie",
    "2–3 jaar",
    "Zoet en kruidig",
    "Dun"
  ],

  "Salie": [
    "Middellandse Zeegebied",
    "Bladeren",
    "Stoomdestillatie",
    "2–3 jaar",
    "Groen en kruidig",
    "Dun"
  ],

  "Citroengras": [
    "Tropische regio's",
    "Gras",
    "Stoomdestillatie",
    "2–3 jaar",
    "Fris, groen en citrusachtig",
    "Dun"
  ],

  "Mandarijn": [
    "Citrusproducerende regio's",
    "Schil",
    "Koude persing",
    "1–2 jaar",
    "Zacht, zoet en citrusachtig",
    "Dun"
  ],

  "Gember": [
    "Azië",
    "Wortelstok",
    "Stoomdestillatie",
    "3–5 jaar",
    "Warm, pittig en kruidig",
    "Dun"
  ],

  "Basilicum": [
    "Europa en Azië",
    "Bladeren",
    "Stoomdestillatie",
    "2–3 jaar",
    "Fris en kruidig",
    "Dun"
  ],

  "Knoflook": [
    "Wereldwijd geteeld",
    "Bol",
    "Meestal stoomdestillatie",
    "2–3 jaar",
    "Zeer intens en karakteristiek",
    "Dun"
  ],

  "Batana Olie": [
    "Midden-Amerika",
    "Palmvrucht",
    "Traditionele verwerking en extractie uit de palmvrucht",
    "12–18 maanden",
    "Kenmerkend en rijk",
    "Zeer rijk"
  ],

  "Castor Olie": [
    "Tropische en subtropische regio's",
    "Zaden",
    "Persing",
    "12–18 maanden",
    "Mild",
    "Zeer rijk en stroperig"
  ],

  "Jojoba Olie": [
    "Onder andere Noord- en Zuid-Amerika",
    "Zaden",
    "Meestal koudgeperst",
    "2–3 jaar",
    "Zeer mild",
    "Licht tot middellicht"
  ],

  "Pompoenpitolie": [
    "Europa en andere pompoenproducerende regio's",
    "Zaden",
    "Koudgeperst",
    "12–18 maanden",
    "Mild nootachtig",
    "Middellicht"
  ],

  "Argan Olie": [
    "Marokko",
    "Pitten van de arganvrucht",
    "Koudgeperst uit ongebrande pitten",
    "12–24 maanden",
    "Mild en licht nootachtig",
    "Middellicht"
  ],

  "Amla Olie": [
    "India en Zuid-Azië",
    "Amla-vrucht",
    "Olie-extract of persing, afhankelijk van product",
    "12–24 maanden",
    "Kruidig en plantaardig",
    "Middelrijk"
  ],

  "Kokos Olie": [
    "Tropische regio's",
    "Vruchtvlees",
    "Persing",
    "18–24 maanden",
    "Mild tot kokosachtig",
    "Middelrijk"
  ],

  "Zwarte Zaad Olie": [
    "Midden-Oosten en Zuidwest-Azië",
    "Zaden",
    "Koudgeperst",
    "12–24 maanden",
    "Kruidig en karakteristiek",
    "Middelrijk"
  ],

  "Vitamine E Olie": [
    "Afhankelijk van plantaardige grondstof",
    "Afhankelijk van bron",
    "Afhankelijk van grondstof en product",
    "12–24 maanden",
    "Zeer mild",
    "Rijk en stroperig"
  ],

  "Zoete Amandel Olie": [
    "Middellandse Zeegebied",
    "Amandelpit",
    "Koudgeperst",
    "12–18 maanden",
    "Zeer mild",
    "Middellicht"
  ],

  "Aloë Vera Olie": [
    "Tropische en subtropische regio's",
    "Aloë vera-blad / olie-extract",
    "Meestal maceratie of olie-extract",
    "12–18 maanden",
    "Zeer mild",
    "Licht tot middellicht"
  ],

  "Rozenbottel Olie": [
    "Onder andere Chili en Europa",
    "Zaden",
    "Koudgeperst",
    "6–12 maanden",
    "Mild plantaardig",
    "Middellicht"
  ],

  "Moringa Olie": [
    "Afrika en Zuid-Azië",
    "Zaden",
    "Koudgeperst",
    "12–24 maanden",
    "Mild plantaardig",
    "Middelrijk"
  ],

  "Neem Olie": [
    "India en Zuid-Azië",
    "Zaden",
    "Koudgeperst",
    "12–18 maanden",
    "Sterk en karakteristiek",
    "Rijk"
  ],

  "Frambozenpit Olie": [
    "Europa",
    "Zaden",
    "Koudgeperst",
    "6–12 maanden",
    "Mild plantaardig",
    "Licht tot middellicht"
  ],

  "Avocado Olie": [
    "Onder andere Kenia, Mexico en andere avocado-producerende regio's",
    "Vruchtvlees",
    "Persing",
    "12–18 maanden",
    "Mild plantaardig",
    "Rijk"
  ],

  "Abrikozenpit Olie": [
    "Onder andere Turkije en Azië",
    "Pitten",
    "Koudgeperst",
    "12 maanden",
    "Mild",
    "Licht"
  ],

  "Cactusvijg Olie": [
    "Noord-Afrika, waaronder Marokko",
    "Zaden",
    "Koudgeperst",
    "12–18 maanden",
    "Mild plantaardig",
    "Middellicht"
  ],

  "Marula Olie": [
    "Zuidelijk Afrika",
    "Pitten",
    "Koudgeperst",
    "12–24 maanden",
    "Mild",
    "Middelrijk"
  ],

  "Tarwekiem Olie": [
    "Europa en andere tarweproducerende regio's",
    "Tarwekiem",
    "Persing",
    "6–12 maanden",
    "Plantaardig",
    "Rijk"
  ],

  "Lijnzaad Olie": [
    "Europa",
    "Zaden",
    "Koudgeperst",
    "3–6 maanden",
    "Plantaardig",
    "Middellicht"
  ],

  "Olijf Olie": [
    "Middellandse Zeegebied",
    "Vrucht",
    "Mechanische persing",
    "12–24 maanden",
    "Kenmerkend plantaardig",
    "Rijk"
  ],

  "Fenegriek Olie": [
    "India en Zuid-Azië",
    "Zaden",
    "Persing of olie-extract, afhankelijk van product",
    "12–18 maanden",
    "Kruidig",
    "Middelrijk"
  ],

  "Walnoot Olie": [
    "Europa en Azië",
    "Walnoten",
    "Koudgeperst",
    "6–12 maanden",
    "Mild nootachtig",
    "Middellicht"
  ],

  "Teunisbloem Olie": [
    "Europa en Noord-Amerika",
    "Zaden",
    "Koudgeperst",
    "6–12 maanden",
    "Mild",
    "Middellicht"
  ],

  "Druivenpit Olie": [
    "Wijnproducerende regio's",
    "Druivenpitten",
    "Persing",
    "6–12 maanden",
    "Zeer mild",
    "Zeer licht"
  ],

  "Duindoornolie": [
    "Europa en Azië",
    "Bessen of zaden, afhankelijk van product",
    "Persing of CO₂-extractie",
    "6–12 maanden",
    "Plantaardig",
    "Rijk en vaak sterk gekleurd"
  ]

};


/* =========================================================
   OLIËN OPBOUWEN
========================================================= */

const oils = RAW
  .trim()
  .split("\n")
  .filter(Boolean)
  .map(line => {

    const [
      name,
      latin,
      typeShort,
      icon,
      tagString
    ] = line.split("|");

    return {
      name,
      latin,
      type:
        typeShort === "E"
          ? "Etherische olie"
          : "Draagolie",
      icon,
      tags: tagString.split(",")
    };

  });


const LIGHT_HAIR = new Set([
  "Jojoba Olie",
  "Druivenpit Olie",
  "Abrikozenpit Olie",
  "Frambozenpit Olie",
  "Pompoenpitolie"
]);


const RICH_HAIR = new Set([
  "Batana Olie",
  "Castor Olie",
  "Argan Olie",
  "Amla Olie",
  "Kokos Olie",
  "Moringa Olie",
  "Avocado Olie",
  "Olijf Olie",
  "Marula Olie",
  "Tarwekiem Olie"
]);


const LIGHT_FACE = new Set([
  "Jojoba Olie",
  "Druivenpit Olie",
  "Abrikozenpit Olie",
  "Frambozenpit Olie"
]);


const RICH_FACE = new Set([
  "Rozenbottel Olie",
  "Cactusvijg Olie",
  "Marula Olie",
  "Teunisbloem Olie",
  "Duindoornolie",
  "Avocado Olie",
  "Vitamine E Olie"
]);


const SENSITIVE_FACE = new Set([
  "Jojoba Olie",
  "Abrikozenpit Olie",
  "Teunisbloem Olie",
  "Aloë Vera Olie"
]);


const FLORAL = new Set([
  "Lavendel",
  "Rozen",
  "Ylang Ylang",
  "Kamille",
  "Geranium",
  "Jasmijn",
  "Lotus",
  "Neroli"
]);


const EARTHY = new Set([
  "Cederhout",
  "Patchouli",
  "Sandelhout",
  "Mirre",
  "Dennen"
]);


const CITRUS = new Set([
  "Bergamot",
  "Citroen",
  "Sinaasappel",
  "Mandarijn",
  "Citroengras"
]);


const WARM = new Set([
  "Vanille",
  "Kaneel",
  "Kruidnagel",
  "Gember",
  "Kurkuma"
]);


const FRESH = new Set([
  "Pepermunt",
  "Eucalyptus",
  "Rozemarijn",
  "Citroen",
  "Citroengras",
  "Tea Tree",
  "Dennen"
]);


function unique(list) {

  return [
    ...new Set(
      (list || []).filter(Boolean)
    )
  ];

}


/* =========================================================
   HAARTYPES
========================================================= */

function getHairTypes(oil) {

  if (
    !oil.tags.includes("Haar") &&
    !oil.tags.includes("Hoofdhuid")
  ) {

    return [];

  }


  if (oil.type === "Etherische olie") {

    if (oil.name === "Knoflook") {

      return [
        "Dik haar",
        "Krullend haar",
        "Kroeshaar"
      ];

    }


    return [
      "Fijn haar",
      "Normaal haar",
      "Dik haar",
      "Golvend haar",
      "Krullend haar"
    ];

  }


  if (LIGHT_HAIR.has(oil.name)) {

    return [
      "Fijn haar",
      "Normaal haar",
      "Golvend haar"
    ];

  }


  if (RICH_HAIR.has(oil.name)) {

    return [
      "Dik haar",
      "Golvend haar",
      "Krullend haar",
      "Kroeshaar",
      "Droog haar"
    ];

  }


  return [
    "Normaal haar",
    "Dik haar",
    "Golvend haar",
    "Krullend haar"
  ];

}


/* =========================================================
   HOOFDHUIDTYPES
========================================================= */

function getScalpTypes(oil) {

  const result = [];


  if (
    !oil.tags.includes("Haar") &&
    !oil.tags.includes("Hoofdhuid")
  ) {

    return result;

  }


  if (
    [
      "Jojoba Olie",
      "Rozemarijn",
      "Pepermunt",
      "Tea Tree",
      "Pompoenpitolie",
      "Fenegriek Olie"
    ].includes(oil.name)
  ) {

    result.push(
      "Normale hoofdhuid",
      "Vette hoofdhuid"
    );

  }


  if (
    [
      "Jojoba Olie",
      "Argan Olie",
      "Amla Olie",
      "Batana Olie",
      "Castor Olie",
      "Kokos Olie",
      "Moringa Olie",
      "Avocado Olie",
      "Fenegriek Olie",
      "Ylang Ylang"
    ].includes(oil.name)
  ) {

    result.push(
      "Droge hoofdhuid"
    );

  }


  if (
    [
      "Jojoba Olie",
      "Lavendel",
      "Kamille",
      "Aloë Vera Olie"
    ].includes(oil.name)
  ) {

    result.push(
      "Gevoelige hoofdhuid"
    );

  }


  return unique(result);

}


/* =========================================================
   HUIDTYPES
========================================================= */

function getSkinTypes(oil) {

  if (
    !oil.tags.includes("Huid") &&
    !oil.tags.includes("Gezicht")
  ) {

    return [];

  }


  if (oil.type === "Etherische olie") {

    if (
      [
        "Lavendel",
        "Kamille"
      ].includes(oil.name)
    ) {

      return [
        "Normale huid",
        "Droge huid",
        "Gevoelige huid"
      ];

    }


    if (oil.name === "Geranium") {

      return [
        "Normale huid",
        "Droge huid",
        "Gemengde huid"
      ];

    }


    if (oil.name === "Tea Tree") {

      return [
        "Vette huid",
        "Onzuivere huid"
      ];

    }


    if (
      [
        "Frankincense",
        "Rozen",
        "Sandelhout",
        "Mirre",
        "Neroli",
        "Jasmijn"
      ].includes(oil.name)
    ) {

      return [
        "Normale huid",
        "Droge huid",
        "Rijpe huid"
      ];

    }


    return [
      "Normale huid"
    ];

  }


  const result = [];


  if (LIGHT_FACE.has(oil.name)) {

    result.push(
      "Normale huid",
      "Gemengde huid",
      "Vette huid"
    );

  }


  if (RICH_FACE.has(oil.name)) {

    result.push(
      "Droge huid",
      "Rijpe huid"
    );

  }


  if (SENSITIVE_FACE.has(oil.name)) {

    result.push(
      "Gevoelige huid"
    );

  }


  if (!result.length) {

    result.push(
      "Normale huid",
      "Droge huid"
    );

  }


  return unique(result);

}


/* =========================================================
   TOEPASSINGEN
========================================================= */

function getApplications(oil) {

  const result = [];


  if (oil.type === "Etherische olie") {

    if (oil.tags.includes("Diffuser")) {
      result.push("Diffuser");
    }

    if (
      oil.tags.includes("Haar") ||
      oil.tags.includes("Hoofdhuid")
    ) {
      result.push(
        "Haar- of hoofdhuidblend"
      );
    }

    if (
      oil.tags.includes("Huid") ||
      oil.tags.includes("Gezicht")
    ) {
      result.push(
        "Verzorgingsolie, passend verdund"
      );
    }

    if (oil.tags.includes("Massage")) {
      result.push("Massageblend");
    }

    if (
      oil.tags.includes("Geur") ||
      oil.tags.includes("Meditatie")
    ) {
      result.push(
        "Parfum- of geurblend"
      );
    }


    if (!result.length) {

      result.push(
        "Geurblend",
        "DIY met geschikte draagolie"
      );

    }


    return unique(result);

  }


  if (
    oil.tags.includes("Gezicht") ||
    oil.tags.includes("Huid")
  ) {
    result.push(
      "Gezichts- of huidolie"
    );
  }


  if (
    oil.tags.includes("Haar") ||
    oil.tags.includes("Hoofdhuid")
  ) {
    result.push(
      "Haar- of hoofdhuidolie"
    );
  }


  if (oil.tags.includes("Massage")) {
    result.push("Massageolie");
  }


  if (oil.tags.includes("Nagels")) {
    result.push(
      "Nagel- en nagelriemolie"
    );
  }


  result.push(
    "Basis voor etherische olie"
  );


  return unique(result);

}


/* =========================================================
   VOORDELEN
========================================================= */

function getBenefits(oil) {

  const result = [];

  const texture =
    oil.texture.toLowerCase();


  if (oil.type === "Draagolie") {

    if (texture.includes("licht")) {

      result.push(
        "Relatief lichte textuur en prettig voor dagelijkse routines"
      );

    }


    if (
      texture.includes("rijk") ||
      oil.tags.includes("Droog")
    ) {

      result.push(
        "Rijk verzorgend karakter voor droge zones of droger haar"
      );

    }


    if (oil.tags.includes("Glans")) {

      result.push(
        "Past goed in routines voor verzorgde glans in de haarlengtes"
      );

    }


    if (oil.tags.includes("Basisolie")) {

      result.push(
        "Geschikt als basis voor passend verdunde etherische oliën"
      );

    }


    if (oil.tags.includes("Gezicht")) {

      result.push(
        "Kan in een eenvoudige gezichtsolieroutine worden gebruikt"
      );

    }


    if (oil.tags.includes("Haar")) {

      result.push(
        "Geschikt voor haarlengtes, haarpunten of pre-wash routines"
      );

    }

  } else {

    if (oil.tags.includes("Diffuser")) {

      result.push(
        "Geeft een herkenbaar aromaprofiel aan diffuserblends"
      );

    }


    if (
      oil.tags.includes("Ontspanning") ||
      oil.tags.includes("Slaap")
    ) {

      result.push(
        "Past goed in een rustige avond- of ontspanningsroutine"
      );

    }


    if (oil.tags.includes("Focus")) {

      result.push(
        "Past goed in frisse werk- en focusblends"
      );

    }


    if (
      oil.tags.includes("Haar") ||
      oil.tags.includes("Hoofdhuid")
    ) {

      result.push(
        "Kan passend verdund worden toegevoegd aan haar- of hoofdhuidblends"
      );

    }


    if (
      oil.tags.includes("Huid") ||
      oil.tags.includes("Gezicht")
    ) {

      result.push(
        "Kan passend verdund worden gebruikt in verzorgingsblends"
      );

    }

  }


  result.push(
    "Goed te combineren met andere oliën uit de PureOil-gids"
  );


  return unique(result);

}


/* =========================================================
   HOE TE GEBRUIKEN
========================================================= */

function getUses(oil) {

  const result = [];


  if (oil.type === "Etherische olie") {

    if (oil.tags.includes("Diffuser")) {

      result.push(
        "Voeg enkele druppels toe aan een diffuser volgens de instructies van je apparaat"
      );

    }


    if (
      oil.tags.includes("Haar") ||
      oil.tags.includes("Hoofdhuid")
    ) {

      result.push(
        "Meng passend verdund door een draagolie voor haar of hoofdhuid"
      );

    }


    if (
      oil.tags.includes("Huid") ||
      oil.tags.includes("Gezicht")
    ) {

      result.push(
        "Gebruik passend verdund in een geschikte draagolie"
      );

    }


    if (oil.tags.includes("Massage")) {

      result.push(
        "Gebruik passend verdund in een massageolie"
      );

    }


    if (!result.length) {

      result.push(
        "Gebruik als klein onderdeel van een passende olie- of geurblend"
      );

    }

  } else {

    if (oil.tags.includes("Gezicht")) {

      result.push(
        "Gebruik enkele druppels op licht vochtige huid"
      );

    }


    if (oil.tags.includes("Haar")) {

      result.push(
        "Gebruik spaarzaam in haarpunten of als pre-wash olie"
      );

    }


    if (oil.tags.includes("Hoofdhuid")) {

      result.push(
        "Masseer een kleine hoeveelheid in op de hoofdhuid"
      );

    }


    if (oil.tags.includes("Massage")) {

      result.push(
        "Gebruik puur of gemengd als massagebasis"
      );

    }


    result.push(
      "Gebruik als draagolie voor passend verdunde etherische olie"
    );

  }


  return unique(result);

}


/* =========================================================
   COMBINEERT GOED MET
========================================================= */

function getCombineNames(oil) {

  /*
    Frankincense krijgt eigen aanbevelingen.
  */

  if (oil.name === "Frankincense") {

    return [
      "Sandelhout",
      "Mirre",
      "Lavendel",
      "Geranium",
      "Jojoba Olie",
      "Rozenbottel Olie"
    ];

  }


  if (oil.type === "Draagolie") {

    if (oil.tags.includes("Haar")) {

      return [
        "Jojoba Olie",
        "Argan Olie",
        "Rozemarijn"
      ].filter(
        name => name !== oil.name
      );

    }


    if (
      oil.tags.includes("Gezicht") ||
      oil.tags.includes("Huid")
    ) {

      return [
        "Jojoba Olie",
        "Rozenbottel Olie",
        "Lavendel",
        "Geranium"
      ].filter(
        name => name !== oil.name
      );

    }


    if (oil.tags.includes("Massage")) {

      return [
        "Zoete Amandel Olie",
        "Lavendel",
        "Sinaasappel"
      ].filter(
        name => name !== oil.name
      );

    }


    return [
      "Jojoba Olie",
      "Lavendel"
    ].filter(
      name => name !== oil.name
    );

  }


  if (
    oil.tags.includes("Haar") ||
    oil.tags.includes("Hoofdhuid")
  ) {

    return [
      "Jojoba Olie",
      "Argan Olie",
      "Rozemarijn",
      "Cederhout"
    ].filter(
      name => name !== oil.name
    );

  }


  if (CITRUS.has(oil.name)) {

    return [
      "Lavendel",
      "Cederhout",
      "Geranium"
    ];

  }


  if (FLORAL.has(oil.name)) {

    return [
      "Bergamot",
      "Sandelhout",
      "Jojoba Olie"
    ];

  }


  if (EARTHY.has(oil.name)) {

    return [
      "Bergamot",
      "Lavendel",
      "Sandelhout"
    ].filter(
      name => name !== oil.name
    );

  }


  return [
    "Lavendel",
    "Bergamot",
    "Jojoba Olie"
  ].filter(
    name => name !== oil.name
  );

}


/* =========================================================
   DATA VERRIJKEN
========================================================= */

function enrichOil(oil) {

  const meta =
    META[oil.name] || [
      "Varieert per batch",
      "Plantmateriaal",
      "Afhankelijk van product",
      "Controleer verpakking",
      "Mild",
      "Olie"
    ];


  oil.origin = meta[0];
  oil.plantPart = meta[1];
  oil.extraction = meta[2];
  oil.shelfLife = meta[3];
  oil.aroma = meta[4];
  oil.texture = meta[5];


  oil.hairTypes =
    getHairTypes(oil);


  oil.scalpTypes =
    getScalpTypes(oil);


  oil.skinTypes =
    getSkinTypes(oil);


  oil.applications =
    getApplications(oil);


  oil.benefits =
    getBenefits(oil);


  oil.uses =
    getUses(oil);


  oil.combineNames =
    getCombineNames(oil);


  oil.suitableFor =
    unique([
      ...oil.tags,
      ...oil.hairTypes,
      ...oil.scalpTypes,
      ...oil.skinTypes
    ]).slice(0, 12);


  oil.intro =
    `${oil.name} is een ${oil.type.toLowerCase()} met een ${oil.aroma.toLowerCase()} karakter. ` +
    `Binnen de PureOil Oliegids past deze olie vooral bij ${oil.tags.slice(0, 3).join(", ").toLowerCase()}.`;


  oil.safety =
    oil.type === "Etherische olie"
      ? "Etherische oliën zijn geconcentreerd. Gebruik passend verdund bij huidgebruik en vermijd contact met ogen."
      : "Voor uitwendig gebruik. Koel, droog en uit direct zonlicht bewaren.";


  /*
    FRANKINCENSE SPECIFIEK
  */

  if (oil.name === "Frankincense") {

    /*
      Geen Diffuser-tag.
      Hierdoor wordt Frankincense niet als
      diffuserolie behandeld.
    */

    oil.tags =
      oil.tags.filter(
        tag => tag !== "Diffuser"
      );


    oil.aroma =
      "Mild, warm, licht houtachtig en licht kruidig";


    oil.intro =
      "Frankincense heeft bij PureOil een milde geur met een warm, licht houtachtig en licht kruidig karakter. " +
      "De olie past vooral goed binnen huidverzorging, gezichtsolieblends, meditatie en rustige verzorgingsroutines.";


    oil.uses = [
      "Gebruik passend verdund in een geschikte draagolie voor huidgebruik",
      "Combineer bijvoorbeeld met Jojoba Olie of Rozenbottel Olie in een verzorgende avondroutine",
      "Gebruik als onderdeel van een rustige meditatie- of parfumblend"
    ];


    oil.applications = [
      "Gezichtsolieblend",
      "Verzorgingsolie",
      "Massageblend",
      "Meditatieblend",
      "Parfumolie"
    ];


    oil.benefits = [
      "Mild geurprofiel",
      "Past goed in rustige verzorgingsroutines",
      "Combineert goed met houtachtige en bloemige oliën",
      "Geschikt als onderdeel van een verzorgende gezichtsolieblend"
    ];


    oil.combineNames = [
      "Sandelhout",
      "Mirre",
      "Lavendel",
      "Geranium",
      "Jojoba Olie",
      "Rozenbottel Olie"
    ];

  }

}


oils.forEach(
  enrichOil
);


/* =========================================================
   DIY RECEPTEN
========================================================= */

const RECIPES = [

  {
    title:
      "Avondblend voor diffuser",

    category:
      "Ontspanning",

    meta:
      "Diffuser · Ontspanning",

    items: [
      "3 druppels Lavendel",
      "2 druppels Bergamot",
      "1 druppel Cederhout"
    ],

    text:
      "Een zachte, warme geurcombinatie voor de avond.",

    steps: [
      "Vul de diffuser volgens de instructies van je apparaat met water.",
      "Voeg Lavendel, Bergamot en Cederhout toe.",
      "Start met een korte verspreidingsduur.",
      "Pas het aantal druppels aan op de grootte van de ruimte."
    ],

    tip:
      "Gebruik in een kleine ruimte eventueel één of twee druppels minder."
  },


  {
    title:
      "Haarolie met Rozemarijn",

    category:
      "Haar",

    meta:
      "Haar · Hoofdhuid",

    items: [
      "30 ml Jojoba Olie",
      "6 druppels Rozemarijn",
      "2 druppels Cederhout"
    ],

    text:
      "Een praktische olieblend voor haar en hoofdhuid.",

    steps: [
      "Doe de Jojoba Olie in een schoon flesje.",
      "Voeg Rozemarijn en Cederhout toe.",
      "Meng voorzichtig.",
      "Breng een kleine hoeveelheid aan op de hoofdhuid.",
      "Masseer enkele minuten in.",
      "Gebruik bijvoorbeeld als pre-wash routine en was daarna uit."
    ],

    tip:
      "Gebruik bij fijn haar niet te veel olie."
  },


  {
    title:
      "Verzorgende gezichtsolie",

    category:
      "Gezicht",

    meta:
      "Gezicht · Avond",

    items: [
      "20 ml Jojoba Olie",
      "10 ml Rozenbottel Olie",
      "1 druppel Frankincense",
      "1 druppel Geranium"
    ],

    text:
      "Een verzorgende olieblend voor een avondroutine.",

    steps: [
      "Meng Jojoba en Rozenbottel Olie in een schoon flesje.",
      "Voeg Frankincense en Geranium toe.",
      "Meng voorzichtig.",
      "Gebruik enkele druppels op een gereinigde huid."
    ],

    tip:
      "Gebruik bij voorkeur eerst een kleine hoeveelheid."
  },


  {
    title:
      "Frisse focusblend",

    category:
      "Focus",

    meta:
      "Diffuser · Focus",

    items: [
      "3 druppels Pepermunt",
      "2 druppels Rozemarijn",
      "2 druppels Citroen"
    ],

    text:
      "Een frisse diffuserblend voor werk- en studiemomenten.",

    steps: [
      "Vul je diffuser met water.",
      "Voeg de oliën toe.",
      "Start de diffuser.",
      "Gebruik minder Pepermunt wanneer je een zachtere geur wilt."
    ],

    tip:
      "Pepermunt is krachtig; één of twee druppels kunnen al voldoende zijn."
  },


  {
    title:
      "Lichte olie voor fijn haar",

    category:
      "Haar",

    meta:
      "Haar · Fijn · Licht",

    items: [
      "20 ml Jojoba Olie",
      "10 ml Druivenpit Olie",
      "3 druppels Rozemarijn"
    ],

    text:
      "Een lichtere haarolie voor fijn haar.",

    steps: [
      "Meng de draagoliën.",
      "Voeg Rozemarijn toe.",
      "Gebruik slechts enkele druppels in de haarpunten of als pre-wash."
    ],

    tip:
      "Begin bij fijn haar altijd met weinig product."
  },


  {
    title:
      "Rijke olie voor krullend haar",

    category:
      "Haar",

    meta:
      "Haar · Krullen · Droog",

    items: [
      "15 ml Argan Olie",
      "10 ml Avocado Olie",
      "5 ml Jojoba Olie"
    ],

    text:
      "Een rijkere olieblend voor krullen en droge haarlengtes.",

    steps: [
      "Meng de drie draagoliën.",
      "Gebruik enkele druppels in de lengtes.",
      "Of gebruik de blend als pre-wash routine."
    ],

    tip:
      "Bij zeer droog haar kun je het aandeel Avocado Olie verhogen."
  },


  {
    title:
      "Batana pre-wash",

    category:
      "Haar",

    meta:
      "Haar · Intensief",

    items: [
      "1 theelepel Batana Olie",
      "1 theelepel Argan Olie"
    ],

    text:
      "Een rijke pre-wash combinatie voor dik of droog haar.",

    steps: [
      "Meng Batana en Argan Olie.",
      "Warm de olie tussen je handen.",
      "Verdeel over lengtes en punten.",
      "Laat intrekken.",
      "Was daarna uit."
    ],

    tip:
      "Voor fijn haar kan deze combinatie snel te zwaar zijn."
  },


  {
    title:
      "Lichte gezichtsolie",

    category:
      "Gezicht",

    meta:
      "Gezicht · Licht",

    items: [
      "20 ml Jojoba Olie",
      "10 ml Druivenpit Olie"
    ],

    text:
      "Een eenvoudige lichte gezichtsolie.",

    steps: [
      "Meng beide oliën in een schoon flesje.",
      "Gebruik twee tot drie druppels.",
      "Breng aan op licht vochtige huid."
    ],

    tip:
      "Gebruik eventueel 's avonds als laatste stap van je routine."
  },


  {
    title:
      "Rijke avond gezichtsolie",

    category:
      "Gezicht",

    meta:
      "Gezicht · Droog · Avond",

    items: [
      "15 ml Rozenbottel Olie",
      "10 ml Marula Olie",
      "5 ml Jojoba Olie"
    ],

    text:
      "Een rijkere gezichtsolie voor de avond.",

    steps: [
      "Meng de drie oliën.",
      "Gebruik enkele druppels op gereinigde huid.",
      "Bewaar het flesje koel en donker."
    ],

    tip:
      "Gebruik minder Marula wanneer je een lichtere textuur wilt."
  },


  {
    title:
      "Massageblend ontspanning",

    category:
      "Massage",

    meta:
      "Massage · Ontspanning",

    items: [
      "30 ml Zoete Amandel Olie",
      "3 druppels Lavendel",
      "2 druppels Bergamot"
    ],

    text:
      "Een zachte massageblend.",

    steps: [
      "Meng alles in een schoon flesje.",
      "Doe een kleine hoeveelheid in de handpalmen.",
      "Verdeel over de huid en masseer rustig in."
    ],

    tip:
      "Gebruik Druivenpit Olie als je een lichtere massageolie wilt."
  },


  {
    title:
      "Bloemige diffuserblend",

    category:
      "Diffuser",

    meta:
      "Diffuser · Bloemig",

    items: [
      "2 druppels Geranium",
      "2 druppels Lavendel",
      "1 druppel Ylang Ylang"
    ],

    text:
      "Een zachte bloemige diffuserblend.",

    steps: [
      "Vul de diffuser met water.",
      "Voeg de oliën toe.",
      "Start met een korte verspreidingsduur."
    ],

    tip:
      "Ylang Ylang is sterk; één druppel is vaak voldoende."
  },


  {
    title:
      "Citrus diffuserblend",

    category:
      "Diffuser",

    meta:
      "Diffuser · Citrus",

    items: [
      "3 druppels Sinaasappel",
      "2 druppels Citroen",
      "1 druppel Bergamot"
    ],

    text:
      "Een frisse en zonnige citrusblend.",

    steps: [
      "Vul je diffuser.",
      "Voeg de citrusoliën toe.",
      "Laat de geur kort verspreiden."
    ],

    tip:
      "Mooi voor overdag."
  },


  {
    title:
      "Zachte slaapblend",

    category:
      "Ontspanning",

    meta:
      "Diffuser · Avond",

    items: [
      "3 druppels Lavendel",
      "2 druppels Kamille",
      "1 druppel Cederhout"
    ],

    text:
      "Een zachte avondblend.",

    steps: [
      "Vul de diffuser.",
      "Voeg de oliën toe.",
      "Gebruik tijdens je avondroutine."
    ],

    tip:
      "Laat Cederhout weg als je de blend bloemiger wilt maken."
  },


  {
    title:
      "Warme winterblend",

    category:
      "Diffuser",

    meta:
      "Diffuser · Warm",

    items: [
      "3 druppels Sinaasappel",
      "1 druppel Kaneel",
      "1 druppel Kruidnagel"
    ],

    text:
      "Een warme, kruidige diffuserblend.",

    steps: [
      "Vul de diffuser.",
      "Voeg eerst Sinaasappel toe.",
      "Voeg daarna één druppel Kaneel en Kruidnagel toe."
    ],

    tip:
      "Kaneel en Kruidnagel zijn zeer sterk, dus gebruik ze spaarzaam."
  },


  {
    title:
      "Bloemige parfumolie",

    category:
      "Geur",

    meta:
      "Roll-on · Bloemig",

    items: [
      "10 ml Jojoba Olie",
      "2 druppels Jasmijn",
      "1 druppel Geranium",
      "1 druppel Bergamot"
    ],

    text:
      "Een bloemige parfumolie.",

    steps: [
      "Doe Jojoba Olie in een roll-on.",
      "Voeg de etherische oliën toe.",
      "Rol het flesje rustig tussen je handen.",
      "Laat de blend eventueel een dag rusten."
    ],

    tip:
      "Gebruik spaarzaam."
  }

];


/* =========================================================
   STATE
========================================================= */

let filter =
  "Alles";


let diyFilter =
  "Alles";


let finder =
  {};


let favs =
  new Set(
    JSON.parse(
      localStorage.getItem(
        "po_favs"
      ) || "[]"
    )
  );


let mine =
  new Set(
    JSON.parse(
      localStorage.getItem(
        "po_mine"
      ) || "[]"
    )
  );


const filters = [
  "Alles",
  "Etherische olie",
  "Draagolie",
  "Haar",
  "Huid",
  "Gezicht",
  "Hoofdhuid",
  "Droog",
  "Licht",
  "Ontspanning",
  "Diffuser",
  "Geur",
  "Focus",
  "Massage",
  "Citrus"
];


const diyFilters = [
  "Alles",
  "Haar",
  "Gezicht",
  "Diffuser",
  "Ontspanning",
  "Focus",
  "Massage",
  "Geur"
];


const $ =
  id =>
    document.getElementById(id);


/* =========================================================
   NAVIGATIE
========================================================= */

function hide() {

  [
    "home",
    "detail",
    "finder",
    "calc",
    "diy",
    "diydetail",
    "myoils",
    "favorites"
  ].forEach(id => {

    const element =
      $(id);


    if (element) {

      element.style.display =
        "none";

    }

  });

}


function nav(button) {

  document
    .querySelectorAll(
      ".po-oliegids-app .nav"
    )
    .forEach(item => {

      item.classList.remove(
        "active"
      );

    });


  if (button) {

    button.classList.add(
      "active"
    );

  }

}


function scrollTopApp() {

  window.scrollTo({
    top: 0,
    behavior: "smooth"
  });

}


function showHome(button) {

  hide();


  $("home").style.display =
    "block";


  nav(
    button || $("nHome")
  );


  renderFilters();

  renderOils();

  scrollTopApp();

}


/* =========================================================
   HOME + ZOEKEN
========================================================= */

function renderFilters() {

  $("filters").innerHTML =
    filters
      .map(item => `

        <button
          type="button"
          class="chip ${
            filter === item
              ? "on"
              : ""
          }"
          onclick="filterBy('${item}')"
        >
          ${item}
        </button>

      `)
      .join("");

}


function filterBy(value) {

  filter =
    value;


  renderFilters();

  renderOils();

}


function oilCard(oil) {

  const safe =
    oil.name.replaceAll(
      "'",
      "\\'"
    );


  return `

    <div
      class="card"
      onclick="openOil('${safe}')"
    >

      <div class="ctop">

        <div class="ico">
          ${oil.icon}
        </div>


        <button
          type="button"
          class="fav ${
            favs.has(oil.name)
              ? "on"
              : ""
          }"
          onclick="toggleFav(event,'${safe}')"
        >
          ${
            favs.has(oil.name)
              ? "♥"
              : "♡"
          }
        </button>

      </div>


      <div class="name">
        ${oil.name}
      </div>


      <div class="latin">
        ${oil.latin}
      </div>


      <div class="tags">
        ${oil.tags
          .slice(0, 3)
          .join(" · ")}
      </div>


      <div class="badge">
        ${oil.type}
      </div>

    </div>

  `;

}


function renderOils() {

  const query =
    ($("search")?.value || "")
      .toLowerCase()
      .trim();


  const results =
    oils.filter(oil => {

      const filterMatch =
        filter === "Alles" ||
        oil.type === filter ||
        oil.tags.includes(filter);


      const text =
        [
          oil.name,
          oil.latin,
          oil.type,
          oil.origin,
          oil.plantPart,
          oil.extraction,
          oil.aroma,
          oil.intro,
          ...oil.tags,
          ...oil.hairTypes,
          ...oil.scalpTypes,
          ...oil.skinTypes
        ]
          .join(" ")
          .toLowerCase();


      const searchMatch =
        !query ||
        text.includes(query);


      return (
        filterMatch &&
        searchMatch
      );

    });


  $("count").textContent =
    `${results.length} van ${oils.length}`;


  $("grid").innerHTML =
    results.length
      ? results
          .map(oilCard)
          .join("")
      : `
        <p
          class="lead"
          style="grid-column:1/-1"
        >
          Geen oliën gevonden.
        </p>
      `;

}


/* =========================================================
   FAVORIETEN
========================================================= */

function toggleFav(
  event,
  name
) {

  event.stopPropagation();


  if (favs.has(name)) {

    favs.delete(name);

  } else {

    favs.add(name);

  }


  localStorage.setItem(
    "po_favs",
    JSON.stringify(
      [...favs]
    )
  );


  renderOils();

}


function showFavorites(button) {

  hide();


  $("favorites").style.display =
    "block";


  nav(
    button || $("nFav")
  );


  const list =
    oils.filter(
      oil =>
        favs.has(oil.name)
    );


  $("favGrid").innerHTML =
    list.length
      ? list
          .map(oilCard)
          .join("")
      : `
        <p
          class="lead"
          style="grid-column:1/-1"
        >
          Je hebt nog geen favorieten.
        </p>
      `;


  scrollTopApp();

}


/* =========================================================
   ECHTE SHOPIFY PRODUCTPAGINA'S
========================================================= */

const productCache =
  new Map();


function normalizeProductName(value) {

  return String(value || "")
    .toLowerCase()
    .normalize("NFD")
    .replace(
      /[\u0300-\u036f]/g,
      ""
    )
    .replace(
      /etherische/g,
      ""
    )
    .replace(
      /100%/g,
      ""
    )
    .replace(
      /puur/g,
      ""
    )
    .replace(
      /natuurlijk/g,
      ""
    )
    .replace(
      /koudgeperst/g,
      ""
    )
    .replace(
      /olie/g,
      ""
    )
    .replace(
      /[^a-z0-9]/g,
      ""
    );

}


function getProductSearchTerm(
  name
) {

  const oil =
    oils.find(
      item =>
        item.name === name
    );


  if (
    oil?.type ===
    "Etherische olie"
  ) {

    return (
      `${name} Etherische Olie`
    );

  }


  return name;

}


/*
  Deze functie vraagt jouw eigen Shopify-winkel
  welk product bij de olienaam hoort.

  Daarna wordt de echte product URL gebruikt.
*/

async function resolveProductUrl(
  name
) {

  if (
    productCache.has(name)
  ) {

    return productCache.get(
      name
    );

  }


  const searchTerm =
    getProductSearchTerm(
      name
    );


  const endpoint =
    `/search/suggest.json?q=${encodeURIComponent(searchTerm)}` +
    `&resources[type]=product` +
    `&resources[limit]=10` +
    `&resources[options][unavailable_products]=show`;


  const response =
    await fetch(
      endpoint,
      {
        headers: {
          Accept:
            "application/json"
        }
      }
    );


  if (!response.ok) {

    throw new Error(
      "Shopify productzoekopdracht mislukt."
    );

  }


  const data =
    await response.json();


  const products =
    data?.resources
      ?.results
      ?.products || [];


  if (!products.length) {

    throw new Error(
      `Geen product gevonden voor ${name}`
    );

  }


  const wanted =
    normalizeProductName(
      name
    );


  let product =
    products.find(item => {

      const title =
        normalizeProductName(
          item.title
        );


      return (
        title === wanted ||
        title.includes(wanted) ||
        wanted.includes(title)
      );

    });


  if (!product) {

    product =
      products[0];

  }


  if (!product?.url) {

    throw new Error(
      "Product heeft geen Shopify URL."
    );

  }


  productCache.set(
    name,
    product.url
  );


  return product.url;

}


async function openProductPage(
  name
) {

  try {

    const url =
      await resolveProductUrl(
        name
      );


    /*
      Zelfde tab:
      bezoeker gaat echt naar productpagina.
    */

    window.location.href =
      url;


  } catch (error) {

    console.error(
      "PureOil productlink:",
      error
    );


    /*
      Alleen fallback als Shopify onverwacht
      geen suggestie geeft.
    */

    window.location.href =
      `/search?q=${encodeURIComponent(
        getProductSearchTerm(name)
      )}&type=product`;

  }

}


/* =========================================================
   KLIKBARE COMBINEERT-GOED-MET
========================================================= */

function renderCombinedOils(
  oil
) {

  return `

    <p
      class="small"
      style="margin-bottom:10px"
    >
      Klik op een olie om direct naar
      het betreffende product te gaan.
    </p>


    <div
      style="
        display:flex;
        flex-wrap:wrap;
        gap:8px;
      "
    >

      ${
        oil.combineNames
          .map(name => {

            const match =
              oils.find(
                item =>
                  item.name === name
              );


            if (!match) {

              return "";

            }


            const safe =
              match.name.replaceAll(
                "'",
                "\\'"
              );


            return `

              <button
                type="button"
                class="pill"
                onclick="openProductPage('${safe}')"
                style="
                  cursor:pointer;
                "
              >
                ${match.icon}
                ${match.name}
                →
              </button>

            `;

          })
          .join("")
      }

    </div>

  `;

}


/* =========================================================
   OLIE DETAILPAGINA
========================================================= */

function openOil(name) {

  const oil =
    oils.find(
      item =>
        item.name === name
    );


  if (!oil) {

    return;

  }


  hide();


  $("detail").style.display =
    "block";


  const safe =
    oil.name.replaceAll(
      "'",
      "\\'"
    );


  const profileTags =
    unique([
      ...oil.hairTypes,
      ...oil.scalpTypes,
      ...oil.skinTypes
    ]);


  $("detailContent").innerHTML = `

    <div class="hero">

      <div class="big">
        ${oil.icon}
      </div>

      <h2>
        ${oil.name}
      </h2>

      <div class="small">
        ${oil.latin}
        ·
        ${oil.type}
      </div>

    </div>


    <div class="box">

      <h3>
        Over deze olie
      </h3>

      <p>
        ${oil.intro}
      </p>

    </div>


    <div class="box">

      <h3>
        Herkomst & productie
      </h3>


      <p>

        <strong>
          Gebruikelijke herkomst
        </strong>

        <br>

        ${oil.origin}

      </p>


      <p>

        <strong>
          Plantdeel
        </strong>

        <br>

        ${oil.plantPart}

      </p>


      <p>

        <strong>
          Extractiemethode
        </strong>

        <br>

        ${oil.extraction}

      </p>


      <p>

        <strong>
          Indicatieve houdbaarheid
        </strong>

        <br>

        ${oil.shelfLife}

      </p>


      <p class="small">

        Exacte herkomst,
        productiemethode en houdbaarheid
        kunnen per PureOil-batch verschillen.

      </p>

    </div>


    <div class="box">

      <h3>
        ${
          oil.type ===
          "Etherische olie"
            ? "Geur & karakter"
            : "Geur & textuur"
        }
      </h3>


      <p>

        <strong>
          Geur
        </strong>

        <br>

        ${oil.aroma}

      </p>


      <p>

        <strong>
          Textuur / structuur
        </strong>

        <br>

        ${oil.texture}

      </p>

    </div>


    ${
      profileTags.length
        ? `

          <div class="box">

            <h3>
              Geschikt voor
            </h3>


            <div
              style="
                display:flex;
                flex-wrap:wrap;
                gap:6px;
              "
            >

              ${
                profileTags
                  .map(item => `

                    <span class="pill">
                      ${item}
                    </span>

                  `)
                  .join("")
              }

            </div>

          </div>

        `
        : ""
    }


    <div class="box">

      <h3>
        Waarvoor wordt deze olie gebruikt?
      </h3>


      <div
        style="
          display:flex;
          flex-wrap:wrap;
          gap:6px;
        "
      >

        ${
          oil.suitableFor
            .map(item => `

              <span class="pill">
                ${item}
              </span>

            `)
            .join("")
        }

      </div>

    </div>


    <div class="box">

      <h3>
        Voordelen binnen je routine
      </h3>


      <ul>

        ${
          oil.benefits
            .map(item => `

              <li>
                ${item}
              </li>

            `)
            .join("")
        }

      </ul>

    </div>


    <div class="box">

      <h3>
        Toepassingen
      </h3>


      <ul>

        ${
          oil.applications
            .map(item => `

              <li>
                ${item}
              </li>

            `)
            .join("")
        }

      </ul>

    </div>


    <div class="box">

      <h3>
        Hoe te gebruiken
      </h3>


      <ul>

        ${
          oil.uses
            .map(item => `

              <li>
                ${item}
              </li>

            `)
            .join("")
        }

      </ul>

    </div>


    <div class="box">

      <h3>
        Combineert goed met
      </h3>


      ${renderCombinedOils(oil)}

    </div>


    <div class="box warn">

      <h3>
        Gebruik & bewaren
      </h3>

      <p>
        ${oil.safety}
      </p>

    </div>


    <button
      class="primary"
      type="button"
      onclick="openProductPage('${safe}')"
    >
      Bekijk ${oil.name} op PureOil.nl →
    </button>


    <button
      class="secondary"
      type="button"
      onclick="addMine('${safe}')"
    >
      ${
        mine.has(oil.name)
          ? "✓ Staat in Mijn oliën"
          : "＋ Ik heb deze olie"
      }
    </button>

  `;


  scrollTopApp();

}


/* =========================================================
   MIJN OLIËN
========================================================= */

function addMine(name) {

  mine.add(name);


  localStorage.setItem(
    "po_mine",
    JSON.stringify(
      [...mine]
    )
  );


  openOil(name);

}


function showMyOils(button) {

  hide();


  $("myoils").style.display =
    "block";


  nav(
    button || $("nMine")
  );


  renderMine();

  scrollTopApp();

}


function toggleMine(
  name,
  checked
) {

  if (checked) {

    mine.add(name);

  } else {

    mine.delete(name);

  }


  localStorage.setItem(
    "po_mine",
    JSON.stringify(
      [...mine]
    )
  );


  renderMine();

}


function renderMine() {

  const query =
    ($("mySearch")?.value || "")
      .toLowerCase();


  const list =
    oils.filter(
      oil =>
        !query ||
        oil.name
          .toLowerCase()
          .includes(query)
    );


  const essentialCount =
    [...mine]
      .filter(name => {

        return (
          oils.find(
            oil =>
              oil.name === name
          )?.type ===
          "Etherische olie"
        );

      })
      .length;


  const carrierCount =
    [...mine]
      .filter(name => {

        return (
          oils.find(
            oil =>
              oil.name === name
          )?.type ===
          "Draagolie"
        );

      })
      .length;


  $("myStats").innerHTML = `

    <div class="statrow">

      <div class="stat">

        <b>
          ${mine.size}
        </b>

        <span>
          oliën thuis
        </span>

      </div>


      <div class="stat">

        <b>
          ${essentialCount}
        </b>

        <span>
          etherisch
        </span>

      </div>


      <div class="stat">

        <b>
          ${carrierCount}
        </b>

        <span>
          draagolie
        </span>

      </div>

    </div>

  `;


  $("myOilList").innerHTML =
    list
      .map(oil => {

        const safe =
          oil.name.replaceAll(
            "'",
            "\\'"
          );


        return `

          <label class="oil-check">

            <input
              type="checkbox"
              ${
                mine.has(oil.name)
                  ? "checked"
                  : ""
              }
              onchange="
                toggleMine(
                  '${safe}',
                  this.checked
                )
              "
            >

            <span>
              ${oil.icon}
            </span>

            <div>

              <b>
                ${oil.name}
              </b>

              <div class="small">
                ${oil.type}
              </div>

            </div>

          </label>

        `;

      })
      .join("");


  $("mySearch").oninput =
    renderMine;

}


/* =========================================================
   OIL FINDER
========================================================= */

function finderBox(
  step,
  title,
  options,
  back = ""
) {

  $("finderContent").innerHTML = `

    <div class="box">

      <div class="small">
        ${step}
      </div>

      <h3>
        ${title}
      </h3>


      <div class="options">

        ${
          options
            .map(option => `

              <button
                type="button"
                onclick="${option.action}"
              >
                ${option.label}
              </button>

            `)
            .join("")
        }

      </div>


      ${
        back
          ? `

            <button
              class="secondary"
              type="button"
              onclick="${back}"
            >
              ← Vorige vraag
            </button>

          `
          : ""
      }

    </div>

  `;

}


function showFinder(button) {

  hide();


  $("finder").style.display =
    "block";


  nav(
    button || $("nFind")
  );


  finder =
    {};


  finderStart();

  scrollTopApp();

}


function finderStart() {

  finderBox(

    "Stap 1",

    "Waarvoor zoek je vooral een olie?",

    [

      {
        label:
          "🌿 Haar & hoofdhuid",

        action:
          "finderArea('hair')"
      },


      {
        label:
          "✨ Gezicht & huid",

        action:
          "finderArea('skin')"
      },


      {
        label:
          "🌸 Diffuser & geur",

        action:
          "finderArea('scent')"
      },


      {
        label:
          "🌙 Ontspanning & avond",

        action:
          "finderArea('relax')"
      },


      {
        label:
          "⚡ Focus & werk",

        action:
          "finderArea('focus')"
      },


      {
        label:
          "🤍 Massage & lichaam",

        action:
          "finderArea('massage')"
      }

    ]

  );

}


function finderArea(area) {

  finder =
    {
      area
    };


  if (area === "hair") {
    finderHairType();
  }


  if (area === "skin") {
    finderSkinType();
  }


  if (area === "scent") {
    finderScentProfile();
  }


  if (area === "relax") {
    finderRelaxUse();
  }


  if (area === "focus") {
    finderFocusUse();
  }


  if (area === "massage") {
    finderMassageUse();
  }

}


function setFinder(
  key,
  value,
  nextFunction
) {

  finder[key] =
    value;


  window[nextFunction]();

}


/* =========================================================
   FINDER - HAAR
========================================================= */

function finderHairType() {

  finderBox(

    "Stap 2 · Haar",

    "Wat is jouw haartype?",

    [

      {
        label:
          "Fijn / dun haar",

        action:
          "setFinder('hairType','Fijn haar','finderScalpType')"
      },


      {
        label:
          "Normaal haar",

        action:
          "setFinder('hairType','Normaal haar','finderScalpType')"
      },


      {
        label:
          "Dik haar",

        action:
          "setFinder('hairType','Dik haar','finderScalpType')"
      },


      {
        label:
          "Golvend haar",

        action:
          "setFinder('hairType','Golvend haar','finderScalpType')"
      },


      {
        label:
          "Krullend haar",

        action:
          "setFinder('hairType','Krullend haar','finderScalpType')"
      },


      {
        label:
          "Kroeshaar",

        action:
          "setFinder('hairType','Kroeshaar','finderScalpType')"
      },


      {
        label:
          "Vooral droog haar",

        action:
          "setFinder('hairType','Droog haar','finderScalpType')"
      }

    ],

    "finderStart()"

  );

}


function finderScalpType() {

  finderBox(

    "Stap 3 · Haar",

    "Hoe voelt je hoofdhuid meestal?",

    [

      {
        label:
          "Normaal",

        action:
          "setFinder('scalpType','Normale hoofdhuid','finderHairGoal')"
      },


      {
        label:
          "Droog",

        action:
          "setFinder('scalpType','Droge hoofdhuid','finderHairGoal')"
      },


      {
        label:
          "Wordt snel vet",

        action:
          "setFinder('scalpType','Vette hoofdhuid','finderHairGoal')"
      },


      {
        label:
          "Gevoelig",

        action:
          "setFinder('scalpType','Gevoelige hoofdhuid','finderHairGoal')"
      },


      {
        label:
          "Geen specifieke voorkeur",

        action:
          "setFinder('scalpType','','finderHairGoal')"
      }

    ],

    "finderHairType()"

  );

}


function finderHairGoal() {

  finderBox(

    "Stap 4 · Haar",

    "Wat is je belangrijkste doel?",

    [

      {
        label:
          "Hoofdhuid verzorgen",

        action:
          "setFinder('need','Hoofdhuid','finderHairTexture')"
      },


      {
        label:
          "Droog haar verzorgen",

        action:
          "setFinder('need','Droog','finderHairTexture')"
      },


      {
        label:
          "Glans & zachtere haarpunten",

        action:
          "setFinder('need','Glans','finderHairTexture')"
      },


      {
        label:
          "Lichte dagelijkse olie",

        action:
          "setFinder('need','Licht','finderHairTexture')"
      },


      {
        label:
          "Intensieve pre-wash",

        action:
          "setFinder('need','Rijk','finderHairTexture')"
      }

    ],

    "finderScalpType()"

  );

}


function finderHairTexture() {

  finderBox(

    "Stap 5 · Haar",

    "Hoe zwaar mag de olie aanvoelen?",

    [

      {
        label:
          "Zo licht mogelijk",

        action:
          "setFinder('texture','Licht','finderHairProductType')"
      },


      {
        label:
          "Gemiddeld",

        action:
          "setFinder('texture','Middellicht','finderHairProductType')"
      },


      {
        label:
          "Rijk en intensief",

        action:
          "setFinder('texture','Rijk','finderHairProductType')"
      },


      {
        label:
          "Maakt niet uit",

        action:
          "setFinder('texture','','finderHairProductType')"
      }

    ],

    "finderHairGoal()"

  );

}


function finderHairProductType() {

  finderBox(

    "Stap 6 · Haar",

    "Welk type olie zoek je?",

    [

      {
        label:
          "Draagolie die ik puur kan gebruiken",

        action:
          "setFinder('type','Draagolie','finderResults')"
      },


      {
        label:
          "Etherische olie voor in een blend",

        action:
          "setFinder('type','Etherische olie','finderResults')"
      },


      {
        label:
          "Laat beide zien",

        action:
          "setFinder('type','','finderResults')"
      }

    ],

    "finderHairTexture()"

  );

}


/* =========================================================
   FINDER - GEZICHT
========================================================= */

function finderSkinType() {

  finderBox(

    "Stap 2 · Gezicht",

    "Hoe zou je jouw huid omschrijven?",

    [

      {
        label:
          "Droog",

        action:
          "setFinder('skinType','Droge huid','finderSkinSensitivity')"
      },


      {
        label:
          "Normaal",

        action:
          "setFinder('skinType','Normale huid','finderSkinSensitivity')"
      },


      {
        label:
          "Gemengd",

        action:
          "setFinder('skinType','Gemengde huid','finderSkinSensitivity')"
      },


      {
        label:
          "Vet / glanzend",

        action:
          "setFinder('skinType','Vette huid','finderSkinSensitivity')"
      },


      {
        label:
          "Rijper / behoefte aan rijke verzorging",

        action:
          "setFinder('skinType','Rijpe huid','finderSkinSensitivity')"
      }

    ],

    "finderStart()"

  );

}


function finderSkinSensitivity() {

  finderBox(

    "Stap 3 · Gezicht",

    "Is je huid snel gevoelig of reactief?",

    [

      {
        label:
          "Ja, vrij gevoelig",

        action:
          "setFinder('sensitive','yes','finderSkinGoal')"
      },


      {
        label:
          "Een beetje",

        action:
          "setFinder('sensitive','mild','finderSkinGoal')"
      },


      {
        label:
          "Nee",

        action:
          "setFinder('sensitive','','finderSkinGoal')"
      }

    ],

    "finderSkinType()"

  );

}


function finderSkinGoal() {

  finderBox(

    "Stap 4 · Gezicht",

    "Wat zoek je vooral?",

    [

      {
        label:
          "Een zeer lichte olie",

        action:
          "setFinder('need','Licht','finderSkinFinish')"
      },


      {
        label:
          "Meer verzorging voor droge huid",

        action:
          "setFinder('need','Droog','finderSkinFinish')"
      },


      {
        label:
          "Een rijke avondolie",

        action:
          "setFinder('need','Rijk','finderSkinFinish')"
      },


      {
        label:
          "Een veelzijdige dagelijkse olie",

        action:
          "setFinder('need','Gezicht','finderSkinFinish')"
      }

    ],

    "finderSkinSensitivity()"

  );

}


function finderSkinFinish() {

  finderBox(

    "Stap 5 · Gezicht",

    "Welke finish heeft je voorkeur?",

    [

      {
        label:
          "Zo licht mogelijk",

        action:
          "setFinder('texture','Licht','finderSkinUse')"
      },


      {
        label:
          "Zacht en gemiddeld",

        action:
          "setFinder('texture','Middellicht','finderSkinUse')"
      },


      {
        label:
          "Rijk en voedend",

        action:
          "setFinder('texture','Rijk','finderSkinUse')"
      }

    ],

    "finderSkinGoal()"

  );

}


function finderSkinUse() {

  finderBox(

    "Stap 6 · Gezicht",

    "Hoe wil je de olie gebruiken?",

    [

      {
        label:
          "Puur als gezichtsolie",

        action:
          "setFinder('use','Puur','finderResults')"
      },


      {
        label:
          "Als basis voor DIY blends",

        action:
          "setFinder('use','Basisolie','finderResults')"
      },


      {
        label:
          "Vooral 's avonds",

        action:
          "setFinder('use','Avond','finderResults')"
      }

    ],

    "finderSkinFinish()"

  );

}


/* =========================================================
   FINDER - DIFFUSER
========================================================= */

function finderScentProfile() {

  finder.use =
    "Diffuser";


  finder.type =
    "Etherische olie";


  finderBox(

    "Stap 2 · Diffuser",

    "Welke geurrichting spreekt je het meest aan?",

    [

      {
        label:
          "🍋 Citrus & fris",

        action:
          "setFinder('scent','Citrus','finderScentMoment')"
      },


      {
        label:
          "🌸 Bloemig",

        action:
          "setFinder('scent','Bloemig','finderScentMoment')"
      },


      {
        label:
          "🌿 Aards & houtachtig",

        action:
          "setFinder('scent','Aards','finderScentMoment')"
      },


      {
        label:
          "🤎 Warm & kruidig",

        action:
          "setFinder('scent','Warm','finderScentMoment')"
      },


      {
        label:
          "❄️ Heel fris",

        action:
          "setFinder('scent','Fris','finderScentMoment')"
      }

    ],

    "finderStart()"

  );

}


function finderScentMoment() {

  finderBox(

    "Stap 3 · Diffuser",

    "Voor welk moment zoek je de geur?",

    [

      {
        label:
          "Ochtend / fris beginnen",

        action:
          "setFinder('need','Fris','finderScentStrength')"
      },


      {
        label:
          "Werk / focus",

        action:
          "setFinder('need','Focus','finderScentStrength')"
      },


      {
        label:
          "Overdag / aangename geur",

        action:
          "setFinder('need','Geur','finderScentStrength')"
      },


      {
        label:
          "Avond / ontspannen",

        action:
          "setFinder('need','Ontspanning','finderScentStrength')"
      }

    ],

    "finderScentProfile()"

  );

}


function finderScentStrength() {

  finderBox(

    "Stap 4 · Diffuser",

    "Hoe aanwezig mag de geur zijn?",

    [

      {
        label:
          "Mild",

        action:
          "setFinder('strength','Mild','finderResults')"
      },


      {
        label:
          "Gemiddeld",

        action:
          "setFinder('strength','Gemiddeld','finderResults')"
      },


      {
        label:
          "Krachtig",

        action:
          "setFinder('strength','Krachtig','finderResults')"
      }

    ],

    "finderScentMoment()"

  );

}


/* =========================================================
   FINDER - ONTSPANNING
========================================================= */

function finderRelaxUse() {

  finderBox(

    "Stap 2 · Ontspanning",

    "Waar wil je de olie vooral voor gebruiken?",

    [

      {
        label:
          "Avond- of slaaproutine",

        action:
          "setFinder('need','Slaap','finderRelaxScent')"
      },


      {
        label:
          "Massage",

        action:
          "setFinder('need','Massage','finderRelaxScent')"
      },


      {
        label:
          "Meditatie",

        action:
          "setFinder('need','Meditatie','finderRelaxScent')"
      },


      {
        label:
          "Rustige geurbeleving",

        action:
          "setFinder('need','Ontspanning','finderRelaxScent')"
      }

    ],

    "finderStart()"

  );

}


function finderRelaxScent() {

  finderBox(

    "Stap 3 · Ontspanning",

    "Welke geur past het beste bij je?",

    [

      {
        label:
          "Bloemig",

        action:
          "setFinder('scent','Bloemig','finderResults')"
      },


      {
        label:
          "Aards & houtachtig",

        action:
          "setFinder('scent','Aards','finderResults')"
      },


      {
        label:
          "Zachte citrus",

        action:
          "setFinder('scent','Citrus','finderResults')"
      },


      {
        label:
          "Geen voorkeur",

        action:
          "setFinder('scent','','finderResults')"
      }

    ],

    "finderRelaxUse()"

  );

}


/* =========================================================
   FINDER - FOCUS
========================================================= */

function finderFocusUse() {

  finder.type =
    "Etherische olie";


  finderBox(

    "Stap 2 · Focus",

    "Welke geur heeft je voorkeur?",

    [

      {
        label:
          "Fris & muntachtig",

        action:
          "setFinder('scent','Fris','finderFocusStrength')"
      },


      {
        label:
          "Citrus",

        action:
          "setFinder('scent','Citrus','finderFocusStrength')"
      },


      {
        label:
          "Kruidig & groen",

        action:
          "setFinder('scent','Kruidig','finderFocusStrength')"
      }

    ],

    "finderStart()"

  );

}


function finderFocusStrength() {

  finderBox(

    "Stap 3 · Focus",

    "Hoe krachtig mag de geur zijn?",

    [

      {
        label:
          "Mild",

        action:
          "setFinder('strength','Mild','finderResults')"
      },


      {
        label:
          "Gemiddeld",

        action:
          "setFinder('strength','Gemiddeld','finderResults')"
      },


      {
        label:
          "Krachtig",

        action:
          "setFinder('strength','Krachtig','finderResults')"
      }

    ],

    "finderFocusUse()"

  );

}


/* =========================================================
   FINDER - MASSAGE
========================================================= */

function finderMassageUse() {

  finder.type =
    "Draagolie";


  finder.need =
    "Massage";


  finderBox(

    "Stap 2 · Massage",

    "Welke textuur zoek je?",

    [

      {
        label:
          "Licht en makkelijk uitsmeerbaar",

        action:
          "setFinder('texture','Licht','finderMassageSkin')"
      },


      {
        label:
          "Gemiddeld",

        action:
          "setFinder('texture','Middellicht','finderMassageSkin')"
      },


      {
        label:
          "Rijk voor droge huid",

        action:
          "setFinder('texture','Rijk','finderMassageSkin')"
      }

    ],

    "finderStart()"

  );

}


function finderMassageSkin() {

  finderBox(

    "Stap 3 · Massage",

    "Hoe voelt de huid meestal?",

    [

      {
        label:
          "Normaal",

        action:
          "setFinder('skinType','Normale huid','finderResults')"
      },


      {
        label:
          "Droog",

        action:
          "setFinder('skinType','Droge huid','finderResults')"
      },


      {
        label:
          "Gevoelig",

        action:
          "setFinder('skinType','Gevoelige huid','finderResults')"
      },


      {
        label:
          "Geen voorkeur",

        action:
          "setFinder('skinType','','finderResults')"
      }

    ],

    "finderMassageUse()"

  );

}


/* =========================================================
   FINDER MATCH HELPERS
========================================================= */

function scentMatch(
  oil,
  scent
) {

  if (!scent) {

    return false;

  }


  if (scent === "Bloemig") {
    return FLORAL.has(oil.name);
  }


  if (scent === "Aards") {
    return EARTHY.has(oil.name);
  }


  if (scent === "Citrus") {

    return (
      CITRUS.has(oil.name) ||
      oil.tags.includes("Citrus")
    );

  }


  if (scent === "Warm") {

    return (
      WARM.has(oil.name) ||
      oil.tags.includes("Warm")
    );

  }


  if (scent === "Fris") {

    return (
      FRESH.has(oil.name) ||
      oil.tags.includes("Fris")
    );

  }


  if (scent === "Kruidig") {

    return (
      oil.tags.includes("Kruidig")
    );

  }


  return (
    oil.tags.includes(scent)
  );

}


function textureMatch(
  oil,
  texture
) {

  if (!texture) {

    return false;

  }


  const value =
    oil.texture.toLowerCase();


  if (texture === "Licht") {

    return (
      oil.tags.includes("Licht") ||
      value.includes("licht") ||
      value.includes("dun")
    );

  }


  if (
    texture ===
    "Middellicht"
  ) {

    return (
      value.includes("middel")
    );

  }


  if (texture === "Rijk") {

    return (
      oil.tags.includes("Rijk") ||
      oil.tags.includes("Droog") ||
      value.includes("rijk") ||
      value.includes("stroperig") ||
      value.includes("voller")
    );

  }


  return false;

}


/* =========================================================
   MATCHPERCENTAGE
========================================================= */

function calculateMatch(oil) {

  /*
    BELANGRIJK:
    Frankincense krijgt NOOIT een score
    bij de Diffuser & geur finder.
  */

  if (
    oil.name === "Frankincense" &&
    (
      finder.area === "scent" ||
      finder.use === "Diffuser" ||
      finder.need === "Diffuser"
    )
  ) {

    return {
      percentage: 0,
      reasons: []
    };

  }


  let earned =
    0;


  let maximum =
    0;


  const reasons =
    [];


  function add(
    points,
    condition,
    reason
  ) {

    maximum +=
      points;


    if (condition) {

      earned +=
        points;


      if (reason) {

        reasons.push(
          reason
        );

      }

    }

  }


  /* HAAR */

  if (
    finder.area === "hair"
  ) {

    add(
      22,

      oil.tags.includes("Haar") ||
      oil.tags.includes("Hoofdhuid"),

      "past bij haar- of hoofdhuidverzorging"
    );

  }


  /* GEZICHT */

  if (
    finder.area === "skin"
  ) {

    add(
      24,

      oil.type === "Draagolie" &&
      (
        oil.tags.includes("Gezicht") ||
        oil.tags.includes("Huid")
      ),

      "geschikt als huid- of gezichtsolie"
    );

  }


  /* DIFFUSER */

  if (
    finder.area === "scent"
  ) {

    add(
      25,

      oil.type === "Etherische olie" &&
      oil.tags.includes("Diffuser"),

      "geschikt voor de diffuser"
    );

  }


  /* ONTSPANNING */

  if (
    finder.area === "relax"
  ) {

    add(
      22,

      oil.tags.some(
        tag =>
          [
            "Ontspanning",
            "Slaap",
            "Meditatie",
            "Massage"
          ].includes(tag)
      ),

      "past bij een rustige routine"
    );

  }


  /* FOCUS */

  if (
    finder.area === "focus"
  ) {

    add(
      22,

      oil.type ===
        "Etherische olie" &&
      (
        oil.tags.includes("Focus") ||
        oil.tags.includes("Fris") ||
        oil.tags.includes("Kruidig")
      ),

      "past bij focus en frisse geurbeleving"
    );

  }


  /* MASSAGE */

  if (
    finder.area === "massage"
  ) {

    add(
      24,

      oil.type === "Draagolie" &&
      (
        oil.tags.includes("Massage") ||
        oil.tags.includes("Basisolie") ||
        oil.tags.includes("Huid")
      ),

      "geschikt als massage- of basisolie"
    );

  }


  /* TYPE OLIE */

  if (finder.type) {

    add(
      16,

      oil.type ===
        finder.type,

      `het gewenste producttype: ${finder.type.toLowerCase()}`
    );

  }


  /* HAARTYPE */

  if (finder.hairType) {

    add(
      24,

      oil.hairTypes.includes(
        finder.hairType
      ),

      `past bij ${finder.hairType.toLowerCase()}`
    );

  }


  /* HOOFDHUID */

  if (finder.scalpType) {

    add(
      18,

      oil.scalpTypes.includes(
        finder.scalpType
      ),

      `past bij ${finder.scalpType.toLowerCase()}`
    );

  }


  /* HUIDTYPE */

  if (finder.skinType) {

    add(
      28,

      oil.skinTypes.includes(
        finder.skinType
      ),

      `past bij ${finder.skinType.toLowerCase()}`
    );

  }


  /* GEVOELIGE HUID */

  if (
    finder.sensitive ===
    "yes"
  ) {

    add(
      12,

      oil.skinTypes.includes(
        "Gevoelige huid"
      ),

      "sluit aan bij je gevoelige huidvoorkeur"
    );

  }


  if (
    finder.sensitive ===
    "mild"
  ) {

    add(
      8,

      oil.skinTypes.includes(
        "Gevoelige huid"
      ) ||
      oil.skinTypes.includes(
        "Normale huid"
      ),

      "past bij een mildere huidroutine"
    );

  }


  /* DOEL */

  if (finder.need) {

    let match =
      oil.tags.includes(
        finder.need
      );


    if (
      finder.need === "Rijk"
    ) {

      match =
        oil.tags.includes("Rijk") ||
        oil.tags.includes("Droog") ||
        textureMatch(
          oil,
          "Rijk"
        );

    }


    if (
      finder.need === "Licht"
    ) {

      match =
        oil.tags.includes("Licht") ||
        textureMatch(
          oil,
          "Licht"
        );

    }


    if (
      finder.need === "Geur"
    ) {

      match =
        oil.tags.includes("Geur") ||
        oil.tags.includes("Diffuser");

    }


    add(
      20,
      match,
      `sluit aan op je doel: ${finder.need.toLowerCase()}`
    );

  }


  /* TEXTUUR */

  if (finder.texture) {

    add(
      18,

      textureMatch(
        oil,
        finder.texture
      ),

      `${finder.texture.toLowerCase()}e textuur`
    );

  }


  /* GEUR */

  if (finder.scent) {

    add(
      22,

      scentMatch(
        oil,
        finder.scent
      ),

      `${finder.scent.toLowerCase()} geurprofiel`
    );

  }


  /* GEURSTERKTE */

  if (finder.strength) {

    const strong = [
      "Pepermunt",
      "Eucalyptus",
      "Oregano",
      "Kaneel",
      "Kruidnagel",
      "Citroengras",
      "Tea Tree"
    ];


    const mild = [
      "Lavendel",
      "Mandarijn",
      "Bergamot",
      "Neroli",
      "Kamille",
      "Sinaasappel"
    ];


    let match =
      true;


    if (
      finder.strength ===
      "Krachtig"
    ) {

      match =
        strong.includes(oil.name) ||
        oil.tags.includes("Kruidig");

    }


    if (
      finder.strength ===
      "Mild"
    ) {

      match =
        mild.includes(oil.name) ||
        FLORAL.has(oil.name);

    }


    add(
      10,
      match,
      `${finder.strength.toLowerCase()}e geurintensiteit`
    );

  }


  let percentage =
    maximum
      ? Math.round(
          earned /
          maximum *
          100
        )
      : 0;


  percentage =
    Math.max(
      0,
      Math.min(
        99,
        percentage
      )
    );


  return {
    percentage,
    reasons:
      unique(reasons)
  };

}


/* =========================================================
   FINDER RESULTATEN
========================================================= */

function finderResults() {

  let ranked =
    oils
      .map(oil => {

        const match =
          calculateMatch(oil);


        return {
          oil,
          ...match
        };

      })
      .filter(
        item =>
          item.percentage >= 25
      )
      .sort(
        (a, b) =>
          b.percentage -
          a.percentage
      )
      .slice(
        0,
        6
      );


  /*
    Extra veiligheid:
    Frankincense verwijderen bij diffuser,
    ook al zou later scoring worden aangepast.
  */

  if (
    finder.area === "scent" ||
    finder.use === "Diffuser"
  ) {

    ranked =
      ranked.filter(
        item =>
          item.oil.name !==
          "Frankincense"
      );

  }


  $("finderContent").innerHTML = `

    <div class="box">

      <div class="eyebrow">
        Jouw persoonlijke selectie
      </div>


      <h3>
        Beste matches
      </h3>


      <p>
        De matchscore is berekend op basis
        van jouw antwoorden over haar- of huidtype,
        toepassing, textuur en voorkeuren.
      </p>


      ${
        ranked
          .map(
            (
              result,
              index
            ) => {

              const oil =
                result.oil;


              const safe =
                oil.name.replaceAll(
                  "'",
                  "\\'"
                );


              return `

                <div
                  class="result"
                  onclick="openOil('${safe}')"
                >

                  <div
                    style="
                      display:flex;
                      justify-content:space-between;
                      gap:12px;
                      align-items:flex-start;
                    "
                  >

                    <b>
                      ${index + 1}.
                      ${oil.icon}
                      ${oil.name}
                    </b>


                    <strong
                      style="
                        white-space:nowrap;
                      "
                    >
                      ${result.percentage}% match
                    </strong>

                  </div>


                  <div class="small">

                    ${oil.type}
                    ·
                    ${oil.tags
                      .slice(0, 3)
                      .join(" · ")}

                  </div>


                  ${
                    result.reasons.length
                      ? `

                        <div
                          class="small"
                          style="
                            margin-top:7px;
                            line-height:1.45;
                          "
                        >

                          <strong>
                            Waarom deze match:
                          </strong>

                          ${result.reasons
                            .slice(0, 3)
                            .join(" · ")}

                        </div>

                      `
                      : ""
                  }

                </div>

              `;

            }
          )
          .join("")
      }


      <button
        class="primary"
        type="button"
        onclick="showFinder()"
      >
        Finder opnieuw starten
      </button>

    </div>

  `;


  scrollTopApp();

}


/* =========================================================
   CALCULATOR
========================================================= */

function showCalc(button) {

  hide();


  $("calc").style.display =
    "block";


  nav(button);

  scrollTopApp();

}


function calculate() {

  const ml =
    Number(
      $("ml").value
    );


  const percentage =
    Number(
      $("pct").value
    );


  const drops =
    Math.round(
      ml *
      (
        percentage /
        100
      ) *
      20
    );


  $("calcResult").innerHTML = `

    <div class="calc-result">

      Voor

      <b>
        ${ml} ml
      </b>

      draagolie bij

      <b>
        ${
          String(
            percentage
          ).replace(
            ".",
            ","
          )
        }%
      </b>:

      <br>

      <strong>
        ≈ ${drops} druppels
      </strong>

      <br>

      <span class="small">
        Gebaseerd op circa
        20 druppels per ml.
      </span>

    </div>

  `;

}


/* =========================================================
   DIY
========================================================= */

function ingredientsOwned(
  recipe
) {

  return recipe.items
    .filter(item => {

      return [...mine]
        .some(name => {

          const shortName =
            name
              .toLowerCase()
              .replace(
                " olie",
                ""
              );


          return item
            .toLowerCase()
            .includes(
              shortName
            );

        });

    })
    .length;

}


function renderDIYFilters() {

  $("diyFilters").innerHTML =
    diyFilters
      .map(item => `

        <button
          type="button"
          class="diy-filter ${
            diyFilter === item
              ? "on"
              : ""
          }"
          onclick="setDIYFilter('${item}')"
        >
          ${item}
        </button>

      `)
      .join("");

}


function setDIYFilter(value) {

  diyFilter =
    value;


  renderDIYFilters();

  renderDIYRecipes();

}


function renderDIYRecipes() {

  const query =
    ($("diySearch")?.value || "")
      .toLowerCase()
      .trim();


  const list =
    RECIPES.filter(
      recipe => {

        const filterMatch =
          diyFilter === "Alles" ||
          recipe.category === diyFilter ||
          recipe.meta.includes(
            diyFilter
          );


        const text =
          [
            recipe.title,
            recipe.category,
            recipe.meta,
            recipe.text,
            recipe.tip || "",
            ...recipe.items,
            ...(recipe.steps || [])
          ]
            .join(" ")
            .toLowerCase();


        return (
          filterMatch &&
          (
            !query ||
            text.includes(query)
          )
        );

      }
    );


  $("diyCount").textContent =
    `${list.length} gevonden`;


  $("recipeList").innerHTML =
    list
      .map(recipe => {

        const safe =
          recipe.title.replaceAll(
            "'",
            "\\'"
          );


        const owned =
          ingredientsOwned(
            recipe
          );


        return `

          <div
            class="recipe"
            onclick="openDIY('${safe}')"
            style="
              cursor:pointer;
            "
          >

            <div class="recipe-top">

              <div>

                <h3>
                  ${recipe.title}
                </h3>

                <div class="small">
                  ${recipe.meta}
                </div>

              </div>


              <span class="recipe-tag">
                ${recipe.category}
              </span>

            </div>


            ${
              owned
                ? `

                  <div
                    class="can"
                    style="
                      margin-top:8px;
                    "
                  >
                    ✓ ${owned}
                    ingrediënt(en)
                    uit Mijn oliën
                  </div>

                `
                : ""
            }


            <p>
              ${recipe.text}
            </p>


            <div class="tipbox">

              <b>
                Bekijk recept →
              </b>

              Ingrediënten,
              stappen en routinetips

            </div>

          </div>

        `;

      })
      .join("");

}


function openDIY(title) {

  const recipe =
    RECIPES.find(
      item =>
        item.title === title
    );


  if (!recipe) {

    return;

  }


  hide();


  $("diydetail").style.display =
    "block";


  $("diyDetailContent").innerHTML = `

    <div class="hero">

      <div class="eyebrow">
        ${recipe.category} · DIY
      </div>

      <h2>
        ${recipe.title}
      </h2>

      <p class="lead">
        ${recipe.text}
      </p>

    </div>


    <div class="box">

      <h3>
        Wat heb je nodig?
      </h3>


      <ul>

        ${
          recipe.items
            .map(item => `

              <li>
                ${item}
              </li>

            `)
            .join("")
        }

      </ul>

    </div>


    <div class="box">

      <h3>
        Stap voor stap
      </h3>


      <ol class="steps">

        ${
          (
            recipe.steps || [
              "Meng de ingrediënten zorgvuldig.",
              "Begin met een kleine hoeveelheid.",
              "Bewaar de blend goed afgesloten."
            ]
          )
            .map(step => `

              <li>
                ${step}
              </li>

            `)
            .join("")
        }

      </ol>

    </div>


    ${
      recipe.tip
        ? `

          <div class="box warn">

            <h3>
              PureOil tip
            </h3>

            <p>
              ${recipe.tip}
            </p>

          </div>

        `
        : ""
    }


    <button
      class="primary"
      type="button"
      onclick="showDIY()"
    >
      Terug naar DIY
    </button>

  `;


  scrollTopApp();

}


function showDIY(button) {

  hide();


  $("diy").style.display =
    "block";


  nav(
    button || $("nDIY")
  );


  renderDIYFilters();

  renderDIYRecipes();


  $("diySearch").oninput =
    renderDIYRecipes;


  scrollTopApp();

}


/* =========================================================
   INIT
========================================================= */

function initPureOilGuide() {

  const app =
    document.getElementById(
      "pureoil-oliegids"
    );


  if (!app) {

    return;

  }


  const search =
    $("search");


  if (
    search &&
    !search.dataset.poBound
  ) {

    search.addEventListener(
      "input",
      renderOils
    );


    search.dataset.poBound =
      "1";

  }


  renderFilters();

  renderOils();

}


if (
  document.readyState ===
  "loading"
) {

  document.addEventListener(
    "DOMContentLoaded",
    initPureOilGuide
  );

} else {

  initPureOilGuide();

}


/* =========================================================
   SHOPIFY THEME EDITOR
========================================================= */

document.addEventListener(
  "shopify:section:load",
  event => {

    if (
      event.target
        ?.querySelector
        ?.(
          "#pureoil-oliegids"
        )
    ) {

      initPureOilGuide();

    }

  }
);


/* =========================================================
   FUNCTIES BESCHIKBAAR VOOR ONCLICK
========================================================= */

Object.assign(
  window,
  {

    showHome,

    filterBy,

    openOil,

    openProductPage,

    toggleFav,

    showFavorites,

    addMine,

    showMyOils,

    toggleMine,

    showFinder,

    finderStart,

    finderArea,

    setFinder,

    finderHairType,

    finderScalpType,

    finderHairGoal,

    finderHairTexture,

    finderHairProductType,

    finderSkinType,

    finderSkinSensitivity,

    finderSkinGoal,

    finderSkinFinish,

    finderSkinUse,

    finderScentProfile,

    finderScentMoment,

    finderScentStrength,

    finderRelaxUse,

    finderRelaxScent,

    finderFocusUse,

    finderFocusStrength,

    finderMassageUse,

    finderMassageSkin,

    finderResults,

    showCalc,

    calculate,

    showDIY,

    setDIYFilter,

    openDIY

  }
);